import { useContext } from 'react'
import GeneralContext from '../components/contexts/GeneralContext'
import Profile from '../components/Profile'
import Sidebar from '../components/Sidebar'
import Friends from './Friends'
import GuestPage from './GuestPage'
import { Route, Routes, Outlet, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

function Main() {
   const { currentTab, getWindowDimensions } = useContext(GeneralContext)
   const navigator = useNavigate()
   // if (currentTab == 'Friends') {
   //    navigator('/main/friends')
   // } else if (currentTab == 'GuestPage') {
   //    navigator('/main/guestPage')
   // } else if (currentTab == 'Profile') {
   //    navigator('/main/guestPage')
   // }

   return (
      <div className="Main">
         <div className="main-screen">
            <Sidebar />
            <div className="screenMain">
               {/* <div className="paddingScroll" id="paddingScroll"></div> */}
               <Outlet />
            </div>
         </div>
      </div>
   )
}
export default Main
